export const MAX_REPORT_DESCRIPTION_LENGTH = 500;
